module.exports = __webpack_public_path__ + "img/multi-one.76c34fc3.svg";